<template>
  <v-layout align-end>
    <v-layout column v-if="balanceData" :class="{ 'text-right': !desktop }">
      <v-layout :justify-end="!desktop">
        <span :class="{ 'desktop-balance-title': desktop, 'balance-title': !desktop }"> {{ $t('guest.balance') }} </span>
      </v-layout>
      <v-layout :justify-end="!desktop">
        <span :class="{ 'desktop-balance': desktop, 'balance': !desktop }"> {{formatAmount(balance)}} {{currency}} </span>
      </v-layout>
    </v-layout>
    <v-progress-circular v-else :color="desktop ? 'white' : 'primary'" indeterminate />
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moneyFormatMixins from '@/mixins/MoneyFormat'
export default {
  props: {
    desktop: Boolean
  },
  computed: {
    ...mapState({
      guest: state => state.guests.read
    }),
    ...mapGetters({
      getBalance: 'guests/getBalance'
    }),
    balanceData () {
      return this.getBalance()
    },
    balance () {
      return this.balanceData ? this.balanceData.balance : null
    },
    currency () {
      return this.balanceData ? this.balanceData.currency.name : null
    }
  },
  mixins: [moneyFormatMixins]
}
</script>

<style lang="scss" scoped>
.balance-title {
  font-size: 16px;
  color: #a5a5a5;
  font-weight: 400;
}
.balance {
  font-size: 26px;
  color: var(--v-primary-base);
  font-weight: 400;
}
.desktop-balance {
  font-size: 22px;
  color: white;
  font-weight: 400;
}
.desktop-balance-title {
  font-size: 12px;
  color: white;
  font-weight: 400;
}
</style>
